import React,  { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import logo from './asset/logo-transparent.png';
import bgVideo from './asset/poppies (3).mp4'
import './App.css';
import CloudQueueRoundedIcon from '@mui/icons-material/CloudQueueRounded';
import StorageRoundedIcon from '@mui/icons-material/StorageRounded';
import CodeRoundedIcon from '@mui/icons-material/CodeRounded';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import VolumeOffRoundedIcon from '@mui/icons-material/VolumeOffRounded';


const cards = [
  {
    icon: CodeRoundedIcon,
    title: "Front-end",
    body: "Création d'interfaces au design soigné pour une expérience fluide."
  },
  {
    icon: StorageRoundedIcon,
    title: "Back-end",
    body: "Gestion des bases de données et développement d'API sécurisées."
  },
  {
    icon: CloudQueueRoundedIcon,
    title: "Cloud",
    body: "Déploiement et hébergement des applications sur des infrastructures cloud."
  },
];

function App() {

  const videoRef = useRef<HTMLVideoElement>(null);
  const [muted, setMuted] = React.useState(true);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error' | 'missing-email'>('idle');
  const [visible, setVisible] = useState(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
  setStatus('sending');
  if (form.email === ''

  ) {
    setStatus('missing-email')
    setVisible(true);
    setTimeout(() => setVisible(false), 5000);  // ← start fade after 5s
    return;
  }
  try {
    await emailjs.send(
      'service_rt6ai9p',
      'template_20k3grl',
      {
        name: form.name,
        email: form.email,
        message: form.message,
      },
      'l4bV-ODlfCRC5_1NM'
    );
    setStatus('sent');
    setVisible(true);
    setForm({ name: '', email: '', message: '' });
    setTimeout(() => setVisible(false), 5000);  // ← start fade after 5s
  } catch {
    setStatus('error');
  }
};

  const handleLoop = () => {
    const video = videoRef.current;
    if (!video) return;
    video.classList.remove('fadeIn');
    void video.offsetWidth; // force reflow to restart animation
    video.classList.add('fadeIn');
    video.currentTime = 0;  // ← restart from beginning
    video.play(); 
  };
  return (
      <div className='App'>
      <div className="video-container">
        
         <video 
         ref={videoRef}
         autoPlay 
         muted={muted}
         playsInline 
         className="background-video fadeIn"
         onEnded={handleLoop}>
          <source src={bgVideo} type="video/mp4" />
        </video>
        <div className="content">
        <nav className="navbar">
        <img src={logo} alt="Albertine" className="logo" />
        <div className="navbar-links">
          <a href="#approach" className="navbar-btn">Approche</a>
          <a href="#contact" className="navbar-btn">Contact</a>
        </div>
      </nav>
      <div className="hero-text">
        <p className="hero-description">
          <span className='highlight-text'>Albertine</span> développe des applications web sur-mesure — pensées comme des
          <span className='highlight-text'> œuvres</span>.
        </p>
      </div>

                <section id="approach" className="cards-section">
            <div className="cards-grid">
              {cards.map((card) => (
                <article key={card.title} className="card">
                  <div className="card-icon">
                    <card.icon sx={{ fontSize: 20, color: 'white' }} />
                  </div>
                  <h3 className="card-title">{card.title}</h3>
                  <p className="card-body">{card.body}</p>
                </article>
              ))}
            </div>
          </section>
          <section id="contact" className="contact-section">

          <h2 className="contact-title">Contactez-nous</h2>
          <div className="contact-form">
            <input
              className="form-input"
              type="text"
              name="name"
              placeholder="Nom"
              value={form.name}
              onChange={handleChange}
            />
            <input
              className="form-input"
              type="email"
              name="email"
              placeholder="Adresse email"
              value={form.email}
              onChange={handleChange}
            />
            <textarea
              className="form-input form-textarea"
              name="message"
              placeholder="Votre message..."
              value={form.message}
              onChange={handleChange}
            />
            <button
              className="form-btn"
              onClick={handleSubmit}
              disabled={status === 'sending'}
            >
              {status === 'sending' ? 'Envoi...' : 'Envoyer'}
            </button>
            {status === 'sent' && (
          <p className={`form-success ${visible ? 'fade-in' : 'fade-out'}`}>
            Message envoyé ✓
          </p>
        )}
                    {status === 'error' && (
          <p className={`form-error ${visible ? 'fade-in' : 'fade-out'}`}>
            Une erreur est survenue, réessayez.
          </p>
        )}

        {status === 'missing-email' && (
          <p className={`form-error ${visible ? 'fade-in' : 'fade-out'}`}>
            Veuillez indiquer votre email.
          </p>
        )}
            
          </div>
        </section>
      <footer className="footer">
        <p className="footer-left">© {new Date().getFullYear()} Albertine — Full Stack Development</p>
        <div className="footer-right">
          <p className="footer-subtitle">"Les Coquelicots" · d'après Claude Monet, 1873</p>
          <p className="footer-subtitle">"Arabesque 1" · d'après Claude Debussy, 1890</p>
        </div>
      </footer>
          </div>
          <button className="sound-btn" onClick={() => setMuted(m => !m)}>
            {muted ?             <div>
              <VolumeOffRoundedIcon sx={{ fontSize: 20, color: 'white' }} />
            </div> : 
                        <div>
              <VolumeUpRoundedIcon sx={{ fontSize: 20, color: 'white' }} />
            </div>}

          
          </button>
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
    </div>
    </div>

  );
}

export default App;
